import * as Yup from "yup";
import { EmailValidation } from "./EmailSchema";

export const EditEmailSchema = () => {
  return Yup.object().shape({
    email: EmailValidation
  });
};
